import React  from 'react';
import { useSelector, useDispatch } from 'react-redux';

import KindSelectInput from './components/KindSelectInput';

import { Modal, TextInput, RadioInput, PhoneNumberInput, Button } from 'hosman-material';
import { updateSalesUser, submitSalesUser, updateErrors } from '../../../../../../../reducers/SellerApp/salesUsersSlice';

const NewSalesUserModal = () => {
  const { sale } = useSelector((state) => state.sellerSales);
  const { salesUser, isSubmitting, errors } = useSelector((state) => state.sellerSalesUsers);
  const dispatch = useDispatch();
  
  const handleSalesUserChange = (e) => {
    const { name, value } = e.target
    dispatch(updateErrors({ ...errors, [name]: null }))
    dispatch(updateSalesUser({ ...salesUser, [name]: value }))
  };
  
  const handleSubmit = (e) => {
    dispatch(submitSalesUser({
      saleId: sale.id,
      salesUserId: salesUser.id,
      params: {
        kind: salesUser.kind,
        signatory: salesUser.signatory,
        user_attributes: {
          id: salesUser.user_id,
          first_name: salesUser.first_name,
          last_name: salesUser.last_name,
          civility: salesUser.civility,
          email: salesUser.email,
          phone_country_code: salesUser.phone_country_code || 'FR',
          phone_number: salesUser.phone_number
        }
      }
    }));
  };

  return (
    <Modal isOpen closeModal={() => dispatch(updateSalesUser(null))}>
      <div className='flex flex-col gap-5 p-6 bg-ih-purple-5' data-testid='NewSalesUserModal'>
        <p className='h3 text-ih-indigo'>{salesUser.id ? 'Edition du signataire' : "Ajout d'un signataire :"}</p>

        <div className={salesUser.active ? 'pb-16' : ''}>
          <KindSelectInput kind={salesUser.kind} setKind={handleSalesUserChange} errors={errors} />
        </div>

        {!salesUser.active &&
          <div className='flex flex-col gap-5'>
            <RadioInput
              label='État civil :'
              name='civility'
              options={[
                { name: 'Monsieur', value: 'mr' },
                { name: 'Madame', value: 'mrs' }
              ]}
              value={salesUser.civility}
              onChange={(val) => handleSalesUserChange({ target: { name: 'civility', value: val }})}
              errors={errors}
            />

            <div className='flex flex-col md:flex-row gap-3'>
              <TextInput label='Prénom' name='first_name' value={salesUser.first_name} onChange={handleSalesUserChange} errors={errors} />
              <TextInput label='Nom' name='last_name' value={salesUser.last_name} onChange={handleSalesUserChange} errors={errors} />
            </div>

            <TextInput label='E-mail' name='email' value={salesUser.email} onChange={handleSalesUserChange} errors={errors} />

            <PhoneNumberInput
              onChangePhone={(val) => handleSalesUserChange({ target: { name: 'phone_number', value: val }})}
              onChangeCountryCode={(val) => handleSalesUserChange({ target: { name: 'phone_country_code', value: val }})}
              phoneValue={salesUser.phone_number }
              countryCodeValue={salesUser.phone_country_code }
              errors={errors}
            />
          </div>
        }

        <div className='flex flex-col md:flex-row md:justify-end gap-3'>
          <Button label='Annuler' type='tertiary' onClick={() => dispatch(updateSalesUser(null))} />
          <Button label='Enregistrer' onClick={handleSubmit} isLoading={isSubmitting} />
        </div>
      </div>
    </Modal>
  );
}

export default NewSalesUserModal;
